export default __webpack_public_path__ + "static/media/gothenburg_logo.69006d7e.svg";